export default "__VITE_ASSET__D6AnLMj9__"